import { Brand, createBranded } from '@deltasierra/type-utilities';

export type MediaTemplatePageGenerationId = Brand<number, 'MediaTemplatePageGenerationId'>;
export const MediaTemplatePageGenerationId = createBranded<MediaTemplatePageGenerationId>();
